<template>
  <div class="customInput">
    <label>{{ label }}</label>
    <div
      :class="[
        label ? 'input--margin' : '',
        'flex align-center input--wrrapper'
      ]"
    >
      <input
        :type="type"
        :name="name"
        :value="value"
        @keyup="onKeyup"
        @keyup.enter="onEnter"
        @change="handleChange($event)"
        @input="$emit('input', $event.target.value)"
        :placeholder="placeholder"
        :disabled="disabled"
        :key="uniqueKey"
      />
      <div class="isLoading" v-if="isLoading"></div>
      <span
        v-if="reset && !isLoading"
        class="cursor mdi mdi-24px mdi-close reset-icon"
        @click="handleReset"
      ></span>
      <span
        v-if="icon"
        :class="`cursor mdi mdi-24px ${icon} input--icon`"
        @click="handleSearch"
      ></span>
    </div>
    <p class="error m-0" v-if="error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Input",
  props: [
    "placeholder",
    "label",
    "name",
    "value",
    "type",
    "error",
    "disabled",
    "uniqueKey",
    "reset",
    "icon",
    "handleSearch",
    "handleReset",
    "isLoading"
  ],
  methods: {
    onKeyup(event) {
      this.$emit("onKeyup", event.target.value);
    },
    handleChange(event) {
      this.$emit("change", event.target.value);
    },
    onEnter(event) {
      this.$emit("enter", event);
    }
  }
};
</script>

<style scoped>
.customInput {
  position: relative;
}

label {
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--muted);
}

input {
  width: 100%;
  padding: 0 8px;
  outline: none;
  background: var(--surface);
  box-sizing: border-box;
  font-size: var(--fs-body);
  line-height: 1.4;
  color: var(--text);
  margin: 0;
  border: none;
  font-family: var(--font-sans);
}

.input--margin {
  margin-top: 6px;
}

.input--wrrapper {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  height: 36px;
  background: var(--surface);
  overflow: hidden;
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}

.input--wrrapper:focus-within {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}

.input--wrrapper .reset-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted-soft);
  padding: 0 6px;
}

.input--wrrapper .input--icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 36px;
  color: var(--muted-soft);
  background: var(--surface-2);
  border-left: 1px solid var(--line);
  padding: 0;
  box-sizing: border-box;
  transition: color var(--dur) var(--ease), background var(--dur) var(--ease);
}

.input--wrrapper .input--icon:hover {
  color: var(--accent-600);
  background: var(--accent-050);
}

.is-active {
  padding-left: 40px !important;
}

input::placeholder {
  font-size: var(--fs-body);
  color: var(--muted-soft);
  letter-spacing: 0;
}

input:disabled {
  background: var(--surface-2);
  color: var(--muted-soft);
  cursor: not-allowed;
}

.isLoading {
  margin-right: 8px;
  border: 4px solid var(--line);
  border-radius: 50%;
  border-top: 4px solid var(--accent-600);
  width: 22px;
  height: 15px;
  -webkit-animation: spin-data-v-54844eca 1s linear infinite;
  animation: spin-data-v-54844eca 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
